import {
  fontSize_32,
  fontSize_headerTitles,
  fontSize_headerTitles35,
  fontSize_headings,
  maxWidth,
} from "../../shared/styleconfig";
import { LatestNews } from "./components/LatestNews";
import { StockList } from "./components/StockList";
import { TopMovers } from "./components/TopMovers";
import { ReactComponent as NoMobileIcon } from "../../assets/image/other/no-mobile.svg";

import myProfile from "../../assets/images/myprofile.png";
import { TopStocks } from "./components/TopStocks";
import { AlgoCollection } from "./components/AlgoCollection";
import { useEffect, useState } from "react";
import Supabase from "../../backend/client";
import { useUser } from "../../context/UserContext";
import { WatchList } from "./components/WatchList";
import { AlgoPopup } from "./components/AlgoPopup";
import { getCommaSeperated } from "../../util/functions";
import axios from "axios";
import { TAAPI_API_KEY } from "../../shared/taapiConfig";
import { useNavigate } from "react-router-dom";

export const UserDashboard = () => {
  const user = useUser();
  const [myStocks, setMyStocks] = useState({});
  const [myCart, setMyCart] = useState([]);
  const [myStocksLoader, setMyStocksLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedAlgo, setSelectedAlgo] = useState(null);
  const navigation = useNavigate();
  const [updateStocks, setUpdateStocks] = useState(false);
  const [portfolio, setPortfolio] = useState({
    initialAmt: 0,
    investmentAge: 0,
    currentValue: 0,
    lastEquity: 0
  });

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      navigation("/");
    }
    document.title = "Dashboard";
  }, []);

  const getMyStocks = async () => {
    try {
      setMyStocksLoader(true);
      
      // Get positions directly from user_positions table
      let { data: positions, error } = await Supabase.from("user_positions")
        .select("*")
        .eq("user_id", user?.user?.id);
        
      if (error) {
        console.error("Error fetching positions:", error);
        setMyStocksLoader(false);
        return;
      }
      
      // Get profile info for beta data connection
      let { data: profile } = await Supabase.from("profiles")
        .select("email")
        .eq("id", user?.user?.id)
        .single();
        
      console.log("Current user profile:", profile);
      
      // Get portfolio summary from beta_signups
      let { data: beta_signup, error: beta_error } = await Supabase.from("beta_signups")
        .select("last_equity,total_equity")
        .eq("email", profile?.email)
        .single();
      
      console.log("Beta signup lookup result:", { data: beta_signup, error: beta_error });
      
      // Transform positions data for display
      const stockPositions = {};
      
      // Process each position and get current prices
      if (positions && positions.length > 0) {
        const stockSymbols = positions.map(pos => pos.symbol);
        const stockPromises = stockSymbols.map(async (symbol) => {
          try {
            const res = await axios.get(
              `https://api.taapi.io/candle?secret=${TAAPI_API_KEY}&type=stocks&symbol=${symbol}&interval=1m`
            );
            return { [symbol]: res?.data };
          } catch (err) {
            console.error(`Error fetching data for ${symbol}:`, err);
            return { [symbol]: null };
          }
        });
        
        const stockResponses = await Promise.all(stockPromises);
        const stockPrices = {};
        
        stockResponses.forEach(item => {
          const key = Object.keys(item)[0];
          stockPrices[key] = item[key];
        });
        
        positions.forEach(position => {
          const currentPrice = stockPrices[position.symbol]?.close || 0;
          const currentValue = position.quantity * currentPrice;
          const purchasedValue = position.quantity * position.average_entry_price;
          
          stockPositions[position.symbol] = {
            protfolioQty: position.quantity,
            avgBuyprice: position.average_entry_price,
            protfolioAmt: purchasedValue,
            currentpotfolioAmt: currentValue
          };
        });
      }
      
      setMyStocks(stockPositions);
      
      // Calculate total portfolio values
      let totalPortfolio = 0;
      let currentValue = 0;
      
      Object.values(stockPositions)?.forEach((item) => {
        totalPortfolio += item?.protfolioAmt;
        currentValue += item?.currentpotfolioAmt;
      });
      
      // Update portfolio with last_equity value, ensuring it's a number
      const newPortfolio = {
        initialAmt: totalPortfolio,
        investmentAge: 0,
        currentValue: currentValue,
        lastEquity: beta_signup?.last_equity || beta_signup?.total_equity || 0
      };
      
      setPortfolio(newPortfolio);
      console.log("Setting portfolio with:", newPortfolio);
      
      setMyStocksLoader(false);
    } catch (error) {
      console.log(error);
      setMyStocksLoader(false);
    }
  };

  const getCartIds = async () => {
    let { data: my_stock_cart, error } = await Supabase.from("my_stock_cart")
      .select("algo_id")
      .eq("user_id", user?.user?.id);
    let cartIds = [...new Set(my_stock_cart?.map((item) => item.algo_id))];
    setMyCart(cartIds);
  };

  useEffect(() => {
    if (user?.user?.id) {
      getMyStocks();
      getCartIds();
    }
  }, [user?.user?.id]);

  const CalcEarning = (CurrentValue, InitialValue) => {
    return CurrentValue - InitialValue
  }

  return (
    <>
      <div className=" flex flex-col justify-center items-center lg:hidden w-full h-[100vh] ">
        <NoMobileIcon className="w-[200px] h-[200px]" />
        <h3>For better experience please use desktop or laptop.</h3>
      </div>

      <div
        className={`dashboard font-[Helvetica LT Std] xs:hidden sm:hidden md2:hidden lg:block`}>
        <div className="pt-[116px] bg-[#001639] flex justify-center">
          <div
            className={`bg-[#0061FC] p-4 rounded-t-[20px] w-[80%] ${maxWidth} flex justify-between`}>
            <div className="flex justify-between flex-col">
              <p
                className={`text-[#76ABFF] font-semibold ${fontSize_headerTitles}`}>
                Dashboard
              </p>
              <p
                className={`text-[#FFFFFF] font-semibold xs:text-[14px] sm:text-[14px]  md:text-[40px] lg:text-[50px] xl:text-[50px]  2xl:text-[50px]`}>
                Portfolio
              </p>
            </div>

            <div className="flex justify-start flex-col gap-[10px]">
              <p
                className={`text-[#FFFFFF] font-[300]  text-[20px] text-right`}>
                Invested Value:{" "}
                <span className="font-bold">
                  {getCommaSeperated(portfolio?.initialAmt)}
                </span>
              </p>
              <p
                className={`text-[#FFFFFF] font-[300]  text-[20px] text-right`}>
                Current Value:{" "}
                <span className="font-bold">
                  {getCommaSeperated(portfolio?.currentValue)}
                </span>
              </p>
              <p
                className={`text-[#FFFFFF] font-[300]  text-[20px] text-right`}>
                Last Equity:{" "}
                <span className="font-bold">
                  {getCommaSeperated(portfolio?.lastEquity)}
                </span>
              </p>
              <p
                className={`text-[#FFFFFF] font-[300]  text-[20px] text-right`}>
                Earning:{" "}
                <span className="font-bold">
                  {getCommaSeperated(CalcEarning(portfolio?.currentValue, portfolio?.initialAmt))}
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* <div
          className={`flex gap-[15px] flex-col lg:flex-row ${maxWidth} mx-auto my-[20px] w-[80%]`}>
          <div className="flex lg:flex-[0.3] h-[400px] bg-[#0061FC] rounded-[20px]"></div>
          <TopMovers />
        </div> */}

        <div
          className={`flex gap-[15px] flex-col lg:flex-row ${maxWidth} mx-auto my-[20px] w-[80%]`}>
          <LatestNews />
          <div className="flex flex-1  h-[657px] bg-[#00163900] rounded-[20px] gap-[15px] flex-col">
            <div className="flex lg:flex-row xs:flex-col gap-[15px] h-[557px]">
              <StockList
                title="My Stocks"
                myStocksLoader={myStocksLoader}
                myStocks={myStocks}
              />
            </div>
            <TopStocks />
          </div>
        </div>
        <AlgoCollection
          setShowPopup={setShowPopup}
          type={"Cart"}
          setSelectedAlgo={setSelectedAlgo}
          cart={myCart}
          setUpdateStocks={setUpdateStocks}
          updateStocks={updateStocks}
        />
        <AlgoCollection
          setShowPopup={setShowPopup}
          type={"Draft"}
          setSelectedAlgo={setSelectedAlgo}
          cart={myCart}
          personalAlgos={true}
          setUpdateStocks={setUpdateStocks}
          updateStocks={updateStocks}
        />
        <AlgoCollection
          setShowPopup={setShowPopup}
          type={"Publish"}
          setSelectedAlgo={setSelectedAlgo}
          cart={myCart}
          getMyStocks={getMyStocks}
          setUpdateStocks={setUpdateStocks}
          updateStocks={updateStocks}
        />
        <AlgoPopup
          show={showPopup}
          setShowPopup={setShowPopup}
          selectedAlgo={selectedAlgo}
          setSelectedAlgo={setSelectedAlgo}
          getMyStocks={getMyStocks}
          cart={myCart}
          updateStocks={updateStocks}
          setUpdateStocks={setUpdateStocks}
        />
      </div>
    </>
  );
};
